<div class="range-form" [formGroup]="form">
  <input type="date" formControlName="startDate" [class.--not-has-content]="!form.value.startDate" class="--from" [min]="minStartDate()" [max]="this.form.value.endDate" />
  <input type="date" formControlName="endDate" [class.--not-has-content]="!form.value.endDate" class="--to" [min]="this.form.value.startDate" [max]="maxEndDate()" />
</div>
